module.exports = __webpack_public_path__ + "img/project_finder_button.9bd4a726.jpg";